const config = {
  ssoUrl: 'https://testing.pt1view.com/lineage/api/redirectWithToken?url=',
};

export default config;
